import styled from 'styled-components';

export const ItemInformationContainer = styled.div`
  max-width: 65%;
  float: left;
  margin-left: 20px;
`;
export const ItemName = styled.h4`
  margin: 0;
  overflow: visible;
  text-overflow: ellipsis;
  max-width: 28rem;
`;
export const ItemPropertyContainer = styled.div`
  margin: 12px 0 12px;
`;
export const ItemPropertyList = styled.ul`
  padding: 0;
  list-style: none;
`;
export const ItemProperty = styled.li``;

export const ItemStatus = styled.span`
  font-weight: bold;
  display: block;
`;
